import MBadge from './Badge.vue';

export default MBadge;
